import React, { useState, useEffect } from 'react';
import {
   Dialog,
   DialogContent,
   DialogDescription,
   DialogFooter,
   DialogHeader,
   DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
// import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ScrollArea } from "@/components/ui/scroll-area";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";

const CSAWPresetModal = ({ isOpen, onClose, onSave, initialPreset }) => {
   const defaultSelectedDocuments = {
      officialReceipt: true,      // Default required docs are checked
      deedOfSale: true,           // Default required docs are checked
      specialPowerOfAttorney: false,
      forestTenureAgreement: false,
      businessPermit: false,
      certificateOfRegistration: false,
      woodProcessingPlantPermit: false
   };

   const [preset, setPreset] = useState({
      registrationType: 'New',
      chainsawStore: '',
      ownerName: '',
      address: '',
      phone: '',
      brand: '',
      model: '',
      serialNumber: '',
      dateOfAcquisition: '',
      powerOutput: '',
      maxLengthGuidebar: '',
      countryOfOrigin: '',
      purchasePrice: '',
      isOwner: false,
      isTenureHolder: false,
      isBusinessOwner: false,
      isPTPRHolder: false,
      isWPPHolder: false,
      selectedDocuments: defaultSelectedDocuments
   });

   useEffect(() => {
      if (initialPreset) {
         setPreset({
            ...initialPreset,
            selectedDocuments: {
               ...defaultSelectedDocuments,
               ...(initialPreset.selectedDocuments || {})
            }
         });
      }
   }, [initialPreset]);

   const handleCheckboxChange = (name, checked) => {
      setPreset(prev => ({
         ...prev,
         [name]: checked,
         // Update document selections based on checkbox changes
         selectedDocuments: {
            ...prev.selectedDocuments,
            specialPowerOfAttorney: name === 'isOwner' ? !checked : prev.selectedDocuments.specialPowerOfAttorney,
            forestTenureAgreement: name === 'isTenureHolder' ? checked : prev.selectedDocuments.forestTenureAgreement,
            businessPermit: name === 'isBusinessOwner' ? checked : prev.selectedDocuments.businessPermit,
            certificateOfRegistration: name === 'isPTPRHolder' ? checked : prev.selectedDocuments.certificateOfRegistration,
            woodProcessingPlantPermit: name === 'isWPPHolder' ? checked : prev.selectedDocuments.woodProcessingPlantPermit,
         }
      }));
   };

   const renderFileRequirements = () => {
      const fileTypes = [
         { type: 'officialReceipt', label: 'Official Receipt', condition: true, path: 'Chainsaw-receipt.jpg' },
         { type: 'deedOfSale', label: 'Deed of Sale', condition: true, path: 'Chainsaw-receipt.jpg' }, // Using same file as receipt for demo
         { type: 'specialPowerOfAttorney', label: 'Special Power of Attorney', condition: !preset.isOwner, path: 'Special-Power-of-Attorney.png' },
         { type: 'forestTenureAgreement', label: 'Forest Tenure Agreement', condition: preset.isTenureHolder, path: 'Forest-Tenure-Agreement.png' },
         { type: 'businessPermit', label: 'Business Permit', condition: preset.isBusinessOwner, path: 'Business permit.png' },
         { type: 'certificateOfRegistration', label: 'Certificate of Registration', condition: preset.isPTPRHolder, path: 'Certificate-of-registration.png' },
         { type: 'woodProcessingPlantPermit', label: 'Wood Processing Plant Permit', condition: preset.isWPPHolder, path: 'wood-processing-permit.png' }
      ];

      return fileTypes.filter(fileType => fileType.condition).map(({ type, label, path }) => (
         <div key={type} className="flex items-center space-x-2 mb-4">
            <Checkbox
               id={type}
               checked={preset.selectedDocuments[type]}
               onCheckedChange={(checked) => {
                  setPreset(prev => ({
                     ...prev,
                     selectedDocuments: {
                        ...prev.selectedDocuments,
                        [type]: checked
                     }
                  }));
               }}
            />
            <div>
               <Label htmlFor={type} className="text-sm text-muted-foreground">{label}</Label>
               <div className="mt-1 text-xs text-gray-500">
                  {type ? 'Required' : 'Optional'}
               </div>
            </div>
         </div>
      ));
   };

   const handleSave = () => {
      const { files, ...presetToSave } = preset;
      localStorage.setItem('csawPreset', JSON.stringify(presetToSave));
      onSave(presetToSave);
      onClose();
      toast.success('CSAW preset saved successfully');
      // toast.succes('Csaw preset saved successfully');
   };

   return (
      <Dialog open={isOpen} onOpenChange={onClose}>
         <DialogContent className="max-w-[600px] max-h-[80vh]">
            <DialogHeader>
               <DialogTitle>Edit CSAW Application Preset</DialogTitle>
               <DialogDescription>
                  Configure default values for test CSAW applications
               </DialogDescription>
            </DialogHeader>

            <ScrollArea className="h-[500px] pr-4">
               <div className="space-y-4 pb-4">
                  {/* <div>
                     <Label>Chainsaw Store</Label>
                     <Input
                        value={preset.chainsawStore}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, chainsawStore: e.target.value }))
                        }
                        placeholder="Enter chainsaw store"
                     />
                  </div>

                  <div>
                     <Label>Owner Name</Label>
                     <Input
                        value={preset.ownerName}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, ownerName: e.target.value }))
                        }
                        placeholder="Enter owner name"
                     />
                  </div>

                  <div>
                     <Label>Address</Label>
                     <Input
                        value={preset.address}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, address: e.target.value }))
                        }
                        placeholder="Enter address"
                     />
                  </div>

                  <div>
                     <Label>Phone</Label>
                     <Input
                        value={preset.phone}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, phone: e.target.value }))
                        }
                        placeholder="Enter phone number"
                     />
                  </div>

                  <div>
                     <Label>Brand</Label>
                     <Input
                        value={preset.brand}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, brand: e.target.value }))
                        }
                        placeholder="Enter brand"
                     />
                  </div>

                  <div>
                     <Label>Model</Label>
                     <Input
                        value={preset.model}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, model: e.target.value }))
                        }
                        placeholder="Enter model"
                     />
                  </div>

                  <div>
                     <Label>Serial Number</Label>
                     <Input
                        value={preset.serialNumber}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, serialNumber: e.target.value }))
                        }
                        placeholder="Enter serial number"
                     />
                  </div>

                  <div>
                     <Label>Date of Acquisition</Label>
                     <Input
                        type="date"
                        value={preset.dateOfAcquisition}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, dateOfAcquisition: e.target.value }))
                        }
                     />
                  </div>

                  <div>
                     <Label>Power Output</Label>
                     <Input
                        value={preset.powerOutput}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, powerOutput: e.target.value }))
                        }
                        placeholder="Enter power output"
                     />
                  </div>

                  <div>
                     <Label>Max Length Guide Bar</Label>
                     <Input
                        value={preset.maxLengthGuidebar}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, maxLengthGuidebar: e.target.value }))
                        }
                        placeholder="Enter max length"
                     />
                  </div>

                  <div>
                     <Label>Country of Origin</Label>
                     <Input
                        value={preset.countryOfOrigin}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, countryOfOrigin: e.target.value }))
                        }
                        placeholder="Enter country"
                     />
                  </div>

                  <div>
                     <Label>Purchase Price</Label>
                     <Input
                        value={preset.purchasePrice}
                        onChange={(e) =>
                           setPreset(prev => ({ ...prev, purchasePrice: e.target.value }))
                        }
                        placeholder="Enter price"
                        type="number"
                     />
                  </div> */}

                  <div className="space-y-2">
                     <Label className="text-base">Additional Information</Label>
                     <div className="space-y-2">
                        <div className="flex items-center space-x-2">
                           <Checkbox
                              id="isOwner"
                              checked={preset.isOwner}
                              onCheckedChange={(checked) => handleCheckboxChange('isOwner', checked)}
                           />
                           <Label htmlFor="isOwner">Is Owner</Label>
                        </div>
                        <div className="flex items-center space-x-2">
                           <Checkbox
                              id="isTenureHolder"
                              checked={preset.isTenureHolder}
                              onCheckedChange={(checked) => handleCheckboxChange('isTenureHolder', checked)}
                           />
                           <Label htmlFor="isTenureHolder">Is Tenure Holder</Label>
                        </div>
                        <div className="flex items-center space-x-2">
                           <Checkbox
                              id="isBusinessOwner"
                              checked={preset.isBusinessOwner}
                              onCheckedChange={(checked) => handleCheckboxChange('isBusinessOwner', checked)}
                           />
                           <Label htmlFor="isBusinessOwner">Is Business Owner</Label>
                        </div>
                        <div className="flex items-center space-x-2">
                           <Checkbox
                              id="isPTPRHolder"
                              checked={preset.isPTPRHolder}
                              onCheckedChange={(checked) => handleCheckboxChange('isPTPRHolder', checked)}
                           />
                           <Label htmlFor="isPTPRHolder">Is PTPR Holder</Label>
                        </div>
                        <div className="flex items-center space-x-2">
                           <Checkbox
                              id="isWPPHolder"
                              checked={preset.isWPPHolder}
                              onCheckedChange={(checked) => handleCheckboxChange('isWPPHolder', checked)}
                           />
                           <Label htmlFor="isWPPHolder">Is WPP Holder</Label>
                        </div>
                     </div>
                  </div>

                  <div className="border-t border-gray-200 pt-4 mt-4">
                     <h3 className="text-lg font-semibold mb-4">Required Documents</h3>
                     {renderFileRequirements()}
                  </div>
               </div>
            </ScrollArea>

            <DialogFooter>
               <Button variant="outline" onClick={onClose}>
                  Cancel
               </Button>
               <Button onClick={handleSave}>Save Preset</Button>
            </DialogFooter>
         </DialogContent>
      </Dialog>
   );
};

export default CSAWPresetModal;